export const navigationItems = [
  { to: '/overview', label: 'workspace.devices', icon: 'devices' },
  { to: '/admin/users', label: 'nav.admin_users', icon: 'users', roles: ['admin', 'support'] },
];
export function canAccessRoute(meta, role) { return !meta.roles || meta.roles.includes(role); }
export function deviceTab(value) { return ['detail', 'dashboard', 'variables', 'reporting'].includes(value) ? value : 'detail'; }
export function safeTarget(value) {
  return typeof value === 'string' && value.startsWith('/') && !value.startsWith('//') && !value.includes('\\') ? value : '/overview';
}
